/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'pip-model',
  'pip-events',
  'utils.userInfo',
  'pip-analytics__messaging',
  'window'
],
function(
  $,
  pip,
  pipEvents,
  userInfo,
  pipAnalyticsMessaging,
  window
){
  var originalZipCode;
  function shouldDisplayEcoRebates() {
      return pip.products.primary.data.rebates && pip.products.primary.data.rebates.hasEcoRebates;
  }

  function updateRebateInformation(eventType, data) {
    var processedResponse = eventType === 'applianceAvailabilityChecked' ? data.processedResponse : data.processedResponse[0];
    updateEcoRebates(processedResponse.zipCode || originalZipCode);
  }

  function attachApplianceAvailabilityEventListener() {
    var applianceAvailabilityEvent = 'applianceAvailabilityCheckedV3';
    pipEvents.appliance[applianceAvailabilityEvent].off('.newApplianceRebate');
    pipEvents.appliance[applianceAvailabilityEvent].on('.newApplianceRebate', updateRebateInformation);
  }

  function isProductAnAppliance() {
    return !!(
      pip
      && pip.products
      && pip.products.primary
      && pip.products.primary.data
      && pip.products.primary.data.info
      && pip.products.primary.data.info.isAppliance
    );
  }

  function updateEcoRebates(zipCode) {
    window._ecr = window._ecr || {};
    window._ecr['ecorebates'] = pip.products.primary.data.itemId.toString();
    window._ecr.options = {
      headingText: "",
      zip: zipCode,
      openDetailsText: "Get up to {{ totalAmount ? totalAmount + ' in ' : offerCount }} Rebate{{ totalAmount || offerCount > 1 ? 's' : ''}} for {{ zipCode }}",
      rebateConsumerTypes: ['residential', 'commercial']
    };
  }

    return {

      init: function init() {
        if(shouldDisplayEcoRebates()){
          $('.buybox__ecorebates').off('.ecorebates').on('click.ecorebates',
            function () {
              pipEvents.ecoRebates.ecoRebatesLinkClicked.trigger(
                pipAnalyticsMessaging.events.overlays.ecorebatesOverlayLinkClicked);
          });
          originalZipCode = userInfo.getTHDStoreZip() ? userInfo.getTHDStoreZip() : userInfo.getAOLZip();
          updateEcoRebates(originalZipCode);
          var ecrScriptUrl = ('https:' == window.document.location.protocol ? 'https://d39vf9bwtb4sua.cloudfront.net' : 'http://static.ecorebates.com') + '/ui/widgets/thd/product.js';

          $.getScript(ecrScriptUrl);

          if (isProductAnAppliance()) {
            attachApplianceAvailabilityEventListener();
          }
        }
      },
      shouldDisplayEcoRebates: shouldDisplayEcoRebates
    }

});

}.call(window));